document.documentElement.classList.remove('no-js');

const formatMoney = (cents) => {
  try {
    return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(cents / 100);
  } catch (_) {
    return `CHF ${(cents / 100).toFixed(2)}`;
  }
};

const updateBundleTotals = (form) => {
  if (!form) return;
  const selectedVariant = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
  const cents = Number(selectedVariant?.dataset.price || 0);
  const quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
  form.querySelectorAll('[data-bundle-total]').forEach((node) => {
    const qty = Number(node.dataset.bundleTotal || 1);
    node.textContent = formatMoney(cents * qty);
  });
  const total = form.querySelector('#KyrzoTotal');
  if (total) total.textContent = formatMoney(cents * quantity);
};

document.addEventListener('change', (event) => {
  if (event.target.matches('.variant-pill input[type="radio"]')) {
    const form = event.target.closest('form');
    form?.querySelectorAll('.variant-pill').forEach((el) => el.classList.remove('active'));
    event.target.closest('.variant-pill')?.classList.add('active');
    updateBundleTotals(form);
  }

  if (event.target.matches('.simple-quantity input')) {
    updateBundleTotals(event.target.closest('form'));
  }
});

document.addEventListener('click', (event) => {
  const card = event.target.closest('.quantity-card');
  if (!card) return;
  const form = card.closest('form');
  form?.querySelectorAll('.quantity-card').forEach((el) => el.classList.remove('active'));
  card.classList.add('active');
  const qtyInput = form?.querySelector('input[name="quantity"]');
  if (qtyInput) qtyInput.value = card.dataset.quantity || '1';
  updateBundleTotals(form);
});

document.querySelectorAll('.kyrzo-product-form').forEach(updateBundleTotals);
